module.exports = __webpack_public_path__ + "static/media/button.b6892625.mp3";